"use client";

import { c as _c } from "react/compiler-runtime";
import { MoonIcon, SunIcon } from "@heroicons/react/24/solid";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";
interface ThemeToggleProps {
  className?: string;
}
export default function ThemeToggle(t0) {
  const $ = _c(13);
  const {
    className
  } = t0;
  const [mounted, setMounted] = useState(false);
  const {
    setTheme,
    theme
  } = useTheme();
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setMounted(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (!mounted) {
    return null;
  }
  let t3;
  if ($[2] !== className) {
    t3 = twMerge("justify-self-end hover:cursor-pointer", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== setTheme || $[5] !== theme) {
    t4 = () => {
      setTheme(theme === "light" ? "dark" : "light");
    };
    $[4] = setTheme;
    $[5] = theme;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== theme) {
    t5 = theme === "light" ? <MoonIcon className="h-8 w-8" /> : <SunIcon className="h-8 w-8" />;
    $[7] = theme;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <button aria-label={"\xC4ndra tema"} className={t3} onClick={t4}>{t5}</button>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}